import { LateralPanelService } from './lateral-panel/lateral-panel.service';
import { TooltipService } from './../shared/tooltip/tooltip.service';
import { Subscription } from 'rxjs';
import { NavigatorService } from '../shared/navigator/navigator.service';
import { NavigatorAnimations } from "../shared/navigator/navigator-animation";
import { Component, OnInit, OnDestroy, ElementRef, ViewChild, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { CommonService } from './common.service';
import { Header } from './header.interface';
import { Footer } from './footer.interface';
import { DataproviderService } from '../dataprovider.service';
import { WebcallsService } from '../webcalls.service';
import { AnalyticsLibraryService } from '../analytics-library.service';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: "app-page",
  templateUrl: "./page.component.html",
  styleUrls: ["./page.component.scss", "./page.component.responsive.scss"],
  animations: [NavigatorAnimations.routeSlide]
})
export class PageComponent implements OnInit, OnDestroy {
  header: Header;
  footer: Footer;
  choices: any = {};
  showNextBtn: boolean = true;
  showInfoChoice: boolean = false;
  centerPageContent: boolean = true;
  routeIndex: number;
  pageSubscriptions: Subscription[] = [];
  loadingMessage:string="";

  @Output() infoClicked = new EventEmitter();

  constructor(
    private ar: ActivatedRoute,
    private router: Router,
    public cs: CommonService,
    private ws: WebcallsService,
    private ds: DataproviderService,
    private ns: NavigatorService,
    public ap: AnalyticsLibraryService,
    private ts: TooltipService,
    private lps: LateralPanelService,
    private viewportScroller: ViewportScroller
  ) {

    this.pageSubscriptions.push(
      this.cs.paramsHeaderChanged.subscribe((params: Header) => {
        this.header = params;
      })
    );
    this.pageSubscriptions.push(
      this.cs.paramsFooterChanged.subscribe((paramsFooter: Footer) => {
        this.footer = paramsFooter;
      })
    );
  }

  ngOnInit() {
    this.viewportScroller.scrollToPosition([0, 0]);
    this.pageSubscriptions.push(
      this.ns.routeIndexChange.subscribe((routeIdx: number) => {
        this.routeIndex = routeIdx;
      })
    );
  }

  ngOnDestroy() {
    this.pageSubscriptions.forEach(sub => {
      sub.unsubscribe();
    });
  }

  beforeConfirm() {
    let that = this;

    if (this.cs.getGAEvent_Title() != null){
      this.ap.sendGAEventWithInfo(this.cs.getGAEvent_Title(),this.cs.getGAEvent_OtherInfo())
      this.cs.setGASelectionEvent(null,null)
    }

    if (this.header.activePage == "whattodo"){

      if ((this.ds.getWhatToDo()["ID"] == 4) && (this.ds.getUUID()!=='')){
        this.ws.getQuotationByUUID(this.ds.getUUID(), 12)
              .subscribe(data => {
                  this.ds.reloadQuotationParams(data);
              });
      }
    } else if (this.header.activePage == "havingbticino") {
      if (this.ds.getBoolHavingBTicino()) {
        this.ds.forceTechnologyID(2);
      }
    } else if (this.header.activePage == "rooms") {
      this.ds.setHousingTypeID();
    } else if (this.header.activePage == "systems") {
      this.ws
        .getPossibleTechnologies(
          this.ds.getLocalizationID(),
          this.ds.getSystems()
        )
        .subscribe(data => {
          if (data["Technologies"]) {
            that.ds.setTechnologies(data["Technologies"]);
            that.ds.setTechnologyID();

            that.ws
              .calculatePointsByParams(
                this.ds.getHousingType(false),
                this.ds.getTechnologyID(),
                this.ds.getLocalizationID(),
                1,
                this.ds.getSystems()
              )
              .subscribe(data => {
                that.ds.setTotalPoints(data);
              });
          }
        });
    } else if (this.header.activePage == "coverconfigurator") {
      that.ws
        .getCover(
          this.ds.getSerieID(),
          this.ds.getFinishingID(),
          this.ds.getTechnologyID()
        )
        .subscribe(data => {
          that.ds.setCover(data);
        });
    }
  }

  analyticsCall() {
    /* Managed with directive */
    var eventData = this.cs.getEventParams();
    if (eventData) {
      return this.ap.getEventTrackerObj(
        eventData.category,
        eventData.label,
        eventData.action,
        null,
        eventData.translate
      );
    }
  }

  confirmBtnClick() {
    this.beforeConfirm();
    this.ns.navigateRoute(this.footer.nextPage, { relativeTo: this.ar });
    // this.chatBotVisibility();
  }

  sendBtnClick() {

    let that = this;

    this.cs.changeLoaderStatus(true);

    this.ap.sendECommerce(that.ds.getPackageItems(), that.ds.getSystems(), that.ds.getTotalAmount());
    //this.ap.sendGAEventWithInfo('IDS_SUMMARY_FORM_SUBMIT');
    this.ap.sendGAEventWithInfoString('IDS_SUMMARY_FORM_SUBMIT', [{ key:'serie', value:  "IDS_FINISHING"+that.ds.getFinishing().ID}]);

    this.ws
      .saveMember(this.ds.getAnagUser(), this.ds.getLocalizationID())
      .subscribe(dataMember => {
        if (dataMember && dataMember["UserID"]) {
          that.ds.setUserID(dataMember["UserID"]);
          that.ws
            .saveQuotation(
              dataMember["UserID"],
              that.ds.getQuotationData(),
              that.ds.getTotalPoints(),
              this.ds.getAddons()
            )
            .subscribe(dataQuotation => {
              let sended=false;
              if (dataQuotation){
                if (dataQuotation["Mail"]){
                  if (dataQuotation["Mail"] === 'mail sent'){
                    //this.ap.sendGAEventWithInfo('IDS_SUMMARY_FORM_SUCCESS');
                    this.ap.sendGAEventWithInfoString('IDS_SUMMARY_FORM_SUCCESS', [{ key:'serie', value:  "IDS_FINISHING"+that.ds.getFinishing().ID}]);
                    sended = true;
                  }else{
                    //this.ap.sendGAEventWithInfo('IDS_SUMMARY_FORM_ERROR');
                    this.ap.sendGAEventWithInfoString('IDS_SUMMARY_FORM_ERROR', [{ key:'serie', value:  "IDS_FINISHING"+that.ds.getFinishing().ID}]);
                  }
                }
              }
              that.cs.changeLoaderStatus(false);
              this.ns.navigateRoute("thanks", { relativeTo: this.ar });
            });
        }
        // else
        // {
        //   that.ws
        //     .saveQuotation(
        //       181,
        //       that.ds.getQuotationData(),
        //       that.ds.getTotalPoints(),
        //       this.ds.getAddons()
        //     )
        //     .subscribe(dataQuotation => {
        //       that.cs.changeLoaderStatus(false);
        //       this.ns.navigateRoute("thanks", { relativeTo: this.ar });
        //     });
        // }
      });
  }

  sendInstallerBtnClick() {
    let that = this;
    this.cs.changeLoaderStatus(true);

    let installerMail = "";
    let installerName = "";
    let installerIDSF = "";
    let installer = this.ds.getSelectedInstallerFullData();
    if (installer){
      if (installer.name=="CREEO TEST"){
        installerMail="roberto.galli@ideatechsrl.com";
      }
      else{
        installerMail=installer.email;
      }
      installerIDSF=installer.idsalesforce;
      installerName=installer.name;
    }
    let additionalInfo = this.ds.getAdditionInfoForInstaller();

    let host = window.location.hostname != "localhost" ? window.location.hostname : "http://casab2c.demorooms.com";
    that.ws.updateQuotation(
        this.ds.getUUID(),
        this.ds.getLocalizationID(),
        additionalInfo["city"],
        additionalInfo["province"],
        additionalInfo["address"],
        additionalInfo["postalcode"],
        additionalInfo["message"],
        additionalInfo["phonenumber"],
        installerMail,
        installerIDSF,
        installerName,
        host
      )
      .subscribe(dataQuotation => {
        // console.log(dataQuotation);
        if (dataQuotation)
        {
          let result = dataQuotation["State"];
          if (result === 'quotation saved')
          {
            that.cs.changeLoaderStatus(false);
            this.ns.navigateRoute("thanks", { relativeTo: this.ar });
          }
        }
      });
  }

  backHomeBtnClick() {
    this.ds.summaryFormData = null;
    this.ns.navigateRoute("");
  }

  onClickInfoRequest(idSelected: number) {
    this.showInfoChoice = !this.showInfoChoice;
  }

  onActivate(event) {
    var el = document.querySelector("main");
    setTimeout(function() {
      el.scrollTop = 0;
    }, 100);
  }

  onScrollMain() {
    this.ts.setTooltipData(null, false, null, true);
  }

  onClickBackButton(){
    window.history.back();
  }

  onSubTitleInfoClick() {
    const subTitleInfoLateralPanelID = "subtitle-info-lateral";
    if (subTitleInfoLateralPanelID) this.lps.open(subTitleInfoLateralPanelID);
    else this.infoClicked.next(0);
  }
}
